module.exports = __webpack_public_path__ + "static/media/microsoft.3aa215b7.svg";